import { AxiosResponse } from "axios";
import API from "../api";

import { Warehouse } from "../models/warehouse";

const ROUTE_NAME = "warehouses";

const WarehouseService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<Warehouse>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Warehouse[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(warehouse: Warehouse): Promise<AxiosResponse<Warehouse>> {
    return await API.post(`/${ROUTE_NAME}`, warehouse);
  },
  async update(id: number, warehouse: Warehouse): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, warehouse);
  },
};

export default WarehouseService;
